<template>
  <div class="contact-embed-inline">
    <iframe
      title="Formulaire de contact TopAuto"
      src="https://top-auto.spondei.com/s/kVZyw5O2N-A="
      width="100%"
      height="900"
      loading="eager"
      referrerpolicy="strict-origin-when-cross-origin"
      class="contact-iframe"
    />
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped lang="scss">
.contact-embed-inline {
  width: 100%;
  max-width: 100%;
}

.contact-iframe {
  display: block;
  width: 100%;
  border: 0;
  background: transparent;
}
</style>
